import { AbsenceCategory } from "~generated";

export const absenceCategoryTranslations = {
  [AbsenceCategory.SCHOOL]: "absenceCategorySchool",
  [AbsenceCategory.SICKNESS]: "absenceCategorySickness",
  [AbsenceCategory.TRAINING]: "absenceCategoryTraining",
  [AbsenceCategory.VACATION]: "absenceCategoryVacation",
  [AbsenceCategory.LEISURE_TIME_ACCOUNT]: "absenceCategoryLeisureTimeAccount",
} as const;
